import { render, staticRenderFns } from "./preparedCards.vue?vue&type=template&id=2a1802b9&scoped=true"
import script from "./preparedCards.vue?vue&type=script&lang=js"
export * from "./preparedCards.vue?vue&type=script&lang=js"
import style0 from "./preparedCards.vue?vue&type=style&index=0&id=2a1802b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1802b9",
  null
  
)

export default component.exports